<i18n src="../../locales/lang.json"></i18n>

<template>
  <div style="position:absolute;top:0px;">
    <div v-for="(el, index) in realValue" v-bind:class="getClass(el,index, realValue.length)" v-bind:style="getPosition(el, index, orientation, direction, realValue.length)">
      <a href="#" data-popup="popover" v-bind:data-index="index" data-trigger="hover" data-delay="600" data-animation="false" data-placement="left" v-bind:data-original-title="el.tooltip" class="menu-link" v-bind:class="{'open-right':el.expanded == true && (el.direction == 'right' || el.direction == null || el.direction == 'downright'),'open-left':el.expanded == true && (el.direction == 'left' || el.direction == 'downleft'),'skin primary-button' : isroot == true}" v-bind:style="getLinkStyle(el, index, orientation, direction, realValue.length)" v-hammer:tap="() => doClick(el)">
        <i class="icon" v-bind:class="el.iconclass" v-bind:style="getTextStyle(el)"></i>
      </a>
      <span v-show="el.label">{{el.label}}</span>
      <nested-menu class="submenu open" @onclick="doClick" v-bind:parentexpanded="el.expanded" v-bind:test="'submenu' + _uid + '_' + index" v-bind:key="'submenu' + _uid + '_' + index" :ref="'submenu' + _uid + '_' + index" v-bind:orientation="el.orientation" v-bind:direction="el.direction" v-model="el.elements" @clickItem="clickItem" />
    </div>
  </div>
</template>

<script>

  import { TimelineLite } from 'gsap'
  import { gsap } from 'gsap';

  export default {
    name: "nested-menu",
    data() {
      return {
        elements: []
      }
    }
    ,
    components: {
      TimelineLite,
      gsap
    },
    methods: {
      getItemClass(el) {
        var retClass = "";
        if (el.itemclass && el.itemclass != null)
          retClass = el.itemclass;
        if (el.expanded == true && (el.direction == 'downright' || el.direction == null))
          retClass += ' open-right';
        if (el.expanded == true && el.direction == 'downleft')
          retClass += ' open-left';
        return retClass;
      },
      getPosition(el, index, orientation, direction, itemcount) {
        var startX = 0;
        var startY = 0;

        var str = ''

        if (direction == "spreadleft") {
          if (orientation == "horizontal") {
            startX = -60;
            if (itemcount > 1)
              startY = 30;
            startY = startY - ((itemcount) * 60 / 2)
            startY = + startY + (index * 60);
          }
        }
        else if (direction == "spreadright") {
          if (orientation == "horizontal") {
            startX = 60;
            if (itemcount > 1)
              startY = 30;
            startY = startY - ((itemcount) * 60 / 2)
            startY = + startY + (index * 60);
          }
        }
        else if (direction == "spreadbottom") {
          if (orientation == "horizontal") {
            startY = 60;
            if (itemcount > 1)
              startX = 30;
            startX = startX - ((itemcount) * 60 / 2)
            startX = + startX + (index * 60);
          }

          //https://stackoverflow.com/questions/25361011/placing-dots-in-an-arc
        }
        else if (direction == "spreadbottom") {
          if (orientation == "horizontal") {
            startY = 60;
            if (itemcount > 1)
              startX = 30;
            startX = startX - ((itemcount) * 60 / 2)
            startX = + startX + (index * 60);
          }
        }
        else if (direction == "downright") {
          if (orientation == "horizontal") {
            //startX = ((itemcount + 1) * 60)
            startX = 60;
            startX = startX + (index * 60);
            startY = 0
          }
          else { //vertical
            //startX = 0
            //startY = ((itemcount + 1) * 60)
            //startY = startY + (index * 60);
            startX = 0
            startY = ((index + 1) * 60);
          }
        }
        else if (direction == "downleft") {
          if (orientation == "horizontal") {
            startX = -((itemcount) * 60)
            startX = startX + (index * 60);
            startY = 0
          }
          else { //vertical
            //startX = 0
            //startY = ((itemcount + 1) * 60)
            //startY = startY + (index * 60);

            startX = 0
            startY = ((index + 1) * 60);
          }
        }

        str += ';margin-left:' + startX + 'px';
        str += ';margin-top:' + startY + 'px';

        return str;
      },
      getLinkStyle(el, index, orientation, direction, itemcount) {
        var str = 'color:inherit'
        if (el.bgColor)
          str += ';background-color:' + el.bgColor;
        return str;
      },
      getTextStyle(el) {
        var str = ''
        if (el.iconstyle && el.iconstyle != null);
          str = el.iconstyle;
        if (el.color)
          str += ';color:' + el.color;
        return str;
      },
      refresh() {
        Vue.set(this, "value", this.value);
        Vue.set(this, "list", this.list);
        this.$forceUpdate();

        //console.log("refs:" + JSON.stringify(this.$refs));

        for (var ref in this.$refs) {
          if (this.$refs[ref].refresh) {
            //alert('calling refresh on a child component')
            this.$refs[ref].refresh();
          }
          //console.log(this.$refs[ref].refresh());
        }
      },
      refreshParent() {
        this.$forceUpdate();
        this.$parent.refreshParent();
      },
      update() {
        this.$forceUpdate();
      },
      setData(data) {
        this.value = data;
        this.refresh();
      },
      refreshParent() {
        this.$forceUpdate();
        this.$parent.refreshParent();
      },
      collapse() {
        /*
        if (this.value != null) {
          for (var i = 0; i < this.value; i++) {
            this.value[i].open = false;
            this.value[i].expanded = false;
          }
        }
        this.$refs.submenu.collapse();
        */
      },
      toggleExpand(el) {
        if (el.static == true)
          return;

        if (!el.elements || el.elements.length == 0) {
          return;
        }

        if (el.expanded == true)
          el.expanded = false;
        else
          el.expanded = true;

        if (el.elements != null) {

          for (var i = 0; i < el.elements.length; i++) {
            el.elements[i].parentexpanded = el.expanded;
          }
        }

        //this.refreshParent();
        this.refresh();
      },
      expand(el) {
        el.expanded = true;
        this.refresh();
      },
      clickItem(el) {
        this.$emit('clickItem', el);
      },
      getClass(el, index, length) {
        var ret = "";
        if (this.parentexpanded != true) {
          ret = "item";
        }
        else {
          ret = "item show";
        }
        return ret;
      },
      addElementByClick() {

      },
      doClick(element) {
        this.$emit("onclick", element)
      },
      doMainClick(e) {
        if (e != null)
          e.preventDefault();
        vm.$root.$emit('check_if_procedure_editor_is_closable');

      },
      getSettings() {
        return { name: 'people', pull: 'clone', put: false }
      },
      onDragMove: function onDragMove(evt) {

        return onMove(evt);
      },
      handleChange() {
        //alert('changed');
      },
      inputChanged(value) {
        this.activeNames = value;
      },
    },
    computed: {
      realValue() {
        return this.value != null ? this.value : this.list;
      },
      
    },
    props: {
      value: {
        required: false,
        type: Array,
        default() {
          return null
        }
      },
      list: {
        required: false,
        type: Array,
        default() {
          return null
        }
      },
      isroot: {
        required: false,
        type: Boolean,
        default: false
      },
      orientation: {
        required: false,
        type: String,
        default: "vertical"
      },
      level: {
        required: false,
        type: Number,
        default: 0
      },
      parentexpanded: {
        required: false,
        type: Boolean,
        default: false
      },
      direction: {
        required: false,
        type: String,
        default: "right"
      },
      
    },
    mounted() {
      
    },
    watch: {
      value: function (newVal, oldVal) {
        
      },
      list: function (newVal, oldVal) {
        
      },
     
    },
  };
</script>


<style scoped>

  .icon {
    padding: 14px !important;
    font-size: 20px !important;
    color: rgb(51, 51, 51);
  }

  .icon-small {
    padding: 8px !important;
    font-size: 18px !important;
    color: rgb(51, 51, 51);
  }

  .icon-2x {
    font-size: 27px !important;
    padding: 11px !important;
    margin-left: -1px;
  }

  .menu-link {
    position: absolute;
    border-radius: 50%;
    -webkit-transition: -webkit-transform .4s ease-in-out;
    -ms-transition: -ms-transform .4s ease-in-out;
    transition: transform .4s ease-in-out;
    line-height: initial;
    box-shadow: 0 1px 3px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.24);
    background-color: rgb(240, 242, 245);
  }

    .menu-link:hover {
      box-shadow: 0 3px 6px rgba(0,0,0,.16),0 3px 6px rgba(0,0,0,.23);
    }

    .menu-link, .menu-link:active, .menu-link:focus {
      outline: none;
      -moz-outline-style: none;
    }

      .menu-link.open-right {
        transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        -webkit-transform: rotate(45deg);
      }

      .menu-link.open-left {
        transform: rotate(-45deg);
        -ms-transform: rotate(-45deg);
        -webkit-transform: rotate(-45deg);
      }

      .menu-link.open-left {
        transform: rotate(-45deg);
        -ms-transform: rotate(-45deg);
        -webkit-transform: rotate(-45deg);
      }

  .submenu .item {
    /*transition here*/
  }

  .item {
    top: 0;
    left: 0;
    opacity: 1;
    margin-left: 0;
    /*transition: top 2s ease-in-out, margin-left 2s ease-in-out;*/
    transition: all 0.5s ease-in-out;
  }

  .menu-link:hover::after {
    position: absolute;
    content: "";
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255,255,255,0.2);
    border-radius: 50%;
  }

  .open .item {
    position: absolute;
    visibility: hidden;
    opacity: 0;
    top: 0;
    margin-left: 0;
  }

  .item.show {
    visibility: visible;
    opacity: 1;
  }
  .menu-container {
    position: absolute;
    top: 0px;
  }
</style>




// WEBPACK FOOTER //
// src/components/menues/nested-menu.vue